import { render, staticRenderFns } from "./update-avatar.vue?vue&type=template&id=07ce101c"
import script from "./update-avatar.vue?vue&type=script&lang=js"
export * from "./update-avatar.vue?vue&type=script&lang=js"
import style0 from "./update-avatar.vue?vue&type=style&index=0&id=07ce101c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports